/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable import/newline-after-import */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable spaced-comment */
/* eslint-disable react/react-in-jsx-scope */

/*/_/_/_/_/_/_/_/_/_/_/_/_/_/

PRASHANTA KUMAR DEY
LWS-REDUX-BATCH-2
Last updated: 24th Feb, 2023 (Friday)

//_/_/_/_/_/_/_/_/_/_/_/_/_/*/

import { Provider } from 'react-redux';
import './App.css';
import Body from './components/Body';
import Header from './components/Header';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <div>
        <Header />
        <Body />
      </div>
    </Provider>
  );
}

export default App;
